import {
  type CreatCustomerDTO,
  type NexiPhoneNumber,
  type NexiRetrievePaymentResponse,
  type OrderAddressDTO,
  type WithOptional
} from 'ecosystem'

export const generateNexiAddresses = (
  nexiResponse: NexiRetrievePaymentResponse
): {
  billingAddress: OrderAddressDTO
  shippingAddress: OrderAddressDTO
  customerInfo: WithOptional<CreatCustomerDTO, 'type'> & { fullName: string; phone: string }
} => {
  const generatePhoneNumber = (phoneNumber?: NexiPhoneNumber) => {
    return `${phoneNumber?.prefix ?? ''}${phoneNumber?.number ?? ''}`
  }
  const { payment } = nexiResponse
  const { billingAddress, privatePerson, shippingAddress } = payment.consumer ?? {}

  const { firstName = '', lastName = '', email = '' } = privatePerson ?? {}

  const mobilePhone = generatePhoneNumber(privatePerson?.phoneNumber)
  const fullName = `${firstName} ${lastName}`

  return {
    billingAddress: {
      address1: billingAddress?.addressLine1 ?? '',
      address2: '',
      country: billingAddress?.country ?? '',
      mobilePhone: generatePhoneNumber(billingAddress?.phoneNumber) || mobilePhone,
      postalCode: billingAddress?.postalCode ?? '',
      postalRegion: billingAddress?.city ?? '',
      attention: billingAddress?.receiverLine ?? fullName,
      reference: ''
    },
    shippingAddress: {
      address1: shippingAddress?.addressLine1 ?? '',
      address2: '',
      country: shippingAddress?.country ?? '',
      mobilePhone: generatePhoneNumber(shippingAddress?.phoneNumber) || mobilePhone,
      postalCode: shippingAddress?.postalCode ?? '',
      postalRegion: shippingAddress?.city ?? '',
      attention: shippingAddress?.receiverLine ?? fullName,
      reference: ''
    },
    customerInfo: {
      email,
      firstName,
      lastName,
      phone: generatePhoneNumber(billingAddress?.phoneNumber) || mobilePhone,
      fullName
    }
  }
}
